// extracted by mini-css-extract-plugin
export var linkText = "_pe-0";